import React, { FC, useMemo } from 'react';
import get from 'lodash/get';
import { useTranslation } from 'react-i18next';

import Select, { SimpleOption } from 'vibo-ui/Select';

import { useEventsFilterable } from '../../EventsListContext';

import { SessionStorageKeys } from 'types/enums';

import useStyles from '../style';

const StatusColumn: FC<ColumnProps> = ({ data = [] }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const { filter, setFilter } = useEventsFilterable();

  const options = useMemo(
    () =>
      data.map(option => ({
        label: t(option.title),
        ...option,
      })),
    [data]
  );

  const handleChange = ({ value: statusId }: SimpleOption) => {
    statusId
      ? sessionStorage.setItem(SessionStorageKeys.euStatus, statusId)
      : sessionStorage.removeItem(SessionStorageKeys.euStatus);

    setFilter((prev: EventsFilter) => ({
      ...prev,
      statusId,
    }));
  };

  return (
    <div className="statusColumn">
      <span className="label">{t('status')}</span>
      <Select
        value={filter.statusId}
        onChange={handleChange}
        components={{
          Option: props => {
            const data = get(props, 'data') as { color: string };

            return (
              <Select.Option {...props}>
                <div className={classes.dot} style={{ backgroundColor: data.color }} />
                {props.label}
              </Select.Option>
            );
          },
        }}
        options={options}
        styleModificator="asLink"
        hideDropdownIndicator
        menuShouldBlockScroll
      />
    </div>
  );
};

export default StatusColumn;
